export default "__VITE_ASSET__ydwz_zF6__"